<template>
  <v-layout mt-4 child-flex>
    <Table
      table-title="Distributors Table"
      :headers="headers"
      :items="distributors"
      icon="local_shipping"
      :actions="actions"
      :items-per-page="20"
      primaryActionText="New Distributor"
      primaryActionIcon="add"
      @primary-action-event="gotoNewDistributor"
    />
  </v-layout>
</template>

<script>
import request from "@/modules/request";
import Table from "@/components/Table";
import { hasPermission } from "@/modules/rbac/permission-manifest";

export default {
  name: "Distributors",
  inject: ["snackBar", "reactiveInjected"],
  async mounted() {
    await this.getDistributors();
  },
  components: {
    Table,
  },
  data() {
    return {
      canCreateDistributor: hasPermission(
        "canCreateDistributor",
        null,
        this.reactiveInjected.activeUser
      ),
      distributors: [],
      headers: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Notes",
          value: "notes",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      loading: true,
      actions: [
        {
          color: "primary",
          click: this.viewDistributor,
          text: "View",
        },
      ],
    };
  },
  methods: {
    gotoNewDistributor() {
      this.$router.push({
        name: "AddDistributor",
      });
    },
    async getDistributors() {
      const results = await request
        .callInternal({
          method: "get",
          route: "/api/admin/distributors",
        })
        .catch((error) => {
          console.error(error);
          return;
        });
      this.loading = false;
      this.distributors = results.data;
    },
    viewDistributor(distributor) {
      this.$router.push({
        name: "Distributor",
        params: { id: distributor._id },
      });
    },
  },
};
</script>
